import React from "react";
// import image from "../../static/images/home.jpg";
import image from "../../static/images/logo.jpg";
import { withApollo } from "react-apollo";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ButtonComponent from "../../components/form-component/ButtonComponent";
import { Logout } from "../../services/graphql/queries/auth";
import { loginAction } from "../../services/redux/actions/loginActions";
import { getCountOfCategories, getCountOfAttachments, getRecentUploadsForDashboard } from "../../services/graphql/queries/category-management";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      heading: "",
      loading: false,
      error: "",
      projectCount: 0,
      attachmentCount: 0,
      notifications: []
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.checkApplication();
    this.getCountOfCategories();
    this.getCountOfAttachments();
    this.getRecentUploadsForDashboard();
  }

  componentWillReceiveProps(prevProps) {
    if (prevProps.permission !== this.props.permission) {
      this.setState({
        loading: false,
      });
    }
  }

  componentDidUpdate() {
    const permission = this.props.permission;
    if (this.state.loading && Object.keys(permission).length) {
      this.setState({
        loading: false,
      });
    }
  }

  logoutHelper = () => {
    let userType = localStorage.getItem("userType");

    if (userType == "1") {
      localStorage.clear();
      this.props.history.push("/");
    }
    this.props.dispatch(loginAction());
    window.close();
  };

  logout = () => {
    this.props.client
      .mutate({
        mutation: Logout,
        variables: { logoutBy: 1 },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        console.log("result@@", result.data.logout.message);
        this.logoutHelper();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  checkApplication = () => {
    const userType = localStorage.getItem("userType");
    if (userType === "1") {
      this.setState({
        heading: "Document Management System",
      });
    }
  };

  getCountOfCategories() {
    this.setState({
      loading: true,
    });
    this.props.client
      .query({
        query: getCountOfCategories,
        variables: {},
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var projCnt = result?.data?.getCountOfCategories;
        this.setState({ projectCount: projCnt })
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  getCountOfAttachments() {
    this.setState({
      loading: true,
    });
    this.props.client
      .query({
        query: getCountOfAttachments,
        variables: {},
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var attachmentCnt = result?.data?.getCountOfAttachments;
        this.setState({ attachmentCount: attachmentCnt })
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  getRecentUploadsForDashboard() {
    this.props.client
      .query({
        query: getRecentUploadsForDashboard,
        variables: { offset: 30 },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        console.log("resd",result)
        var notificationArr =  JSON.parse(result.data.getRecentUploadsForDashboard);
        this.setState({ notifications: notificationArr })
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }
  
  render() {
    const { heading, projectCount, attachmentCount, notifications } = this.state;
    const { permission, isLoggedIn } = this.props;
    console.log(isLoggedIn, permission);
    console.log("notifications",notifications)
    
    if (this.state.loading) {
      return <span>Loading...</span>;
    }
    return (
      <div className="landing-screen-container">
        {permission && Object.keys(permission).length === 0 ? (
          <div className="center">
            <div className="permision-message">
              You do not have access to {heading}. <br /> Kindly contact
              Administrator for further information.
            </div>
            <div className="text-center">
              <ButtonComponent
                type="submit"
                className="btn-danger mt-4"
                title="Close"
                onClick={() => {
                  this.logout();
                }}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="notifications-container-new">
              <h2>Recent Uploads</h2>
              <div className="notifications-list-new">
                {notifications && notifications.length > 0 ? (
                  <div
                    className="notifications-inner-new has-notifications"
                    onMouseEnter={() => document.querySelector(".notifications-inner-new").style.animationPlayState = "paused"}
                    onMouseLeave={() => document.querySelector(".notifications-inner-new").style.animationPlayState = "running"}
                  >
                    {notifications.map((notification, index) => (
                      <div key={index} className="notification-item-new">
                        Document{" "}
                        <span className="highlight">{notification.name}</span> has been uploaded in{" "}
                        <span className="highlight">{notification.folderStructure.replace(/\//g, " -> ")}</span> by{" "}
                        <span className="highlight">{notification.userName}</span> on{" "}
                        <span className="highlight">{notification.createdOn}</span>
                      </div>
                    ))}
                    {/* Add a blank div for visual gap before looping */}
                    <div style={{ height: "50px" }}></div>
                  </div>
                ) : (
                  <div className="no-notifications">No notifications available</div>
                )}
              </div>
            </div>

            <div className="badge-container-new">
              <div className="badge-column">
                <div className="badge-new badge-left">
                  <div className="badge-icon-new">
                    <i className="fas fa-th-list"></i>{" "}
                  </div>
                  <div className="badge-content-new">
                    <div className="badge-count-new">{projectCount}</div>
                    <div className="badge-title-new">Projects</div>
                  </div>
                </div>
              </div>
              <div className="badge-column">
                <div className="badge-new badge-right">
                  <div className="badge-icon-new">
                    <i className="fas fa-file-alt"></i>{" "}
                  </div>
                  <div className="badge-content-new">
                    <div className="badge-count-new">{attachmentCount}</div>
                    <div className="badge-title-new">Documents</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  isLoggedIn: state.auth.isLoggedIn,
  permission: state.auth.permission,
});

export default connect(mapStateToProps)(withRouter(withApollo(Home)));
